export default {
  upper: (value: string): string => {
    return value.toUpperCase();
  }
}